<template>
  <tr>
    <td>{{item.protoId | getProtoAlias}}</td>
    <td class="text-right">{{item.amount | getFormattedNumber}}</td>
    <td
      class="text-right"
      :class="deltaClass"
    >
      {{deltaStr}}
    </td>
    <td class="new-amount-cont">
      <input
        type="number"
        v-model="newAmountStr"
        min="0"
        class="new-amount-input form-control"
        :class="newAmountClass"
      >
    </td>
  </tr>
</template>

<script>
import { InventoryItemData } from '../../model/player_inventory.js';
import { convertDifferenceToOptionalStr } from '../../util.js';

export default {
  name: 'ItemEditor',

  props: {
    item: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      newAmountStr: this.item.amount.toString(),
    };
  },

  computed: {
    /** @returns {number} */
    newAmount() {
      const trimmedNewAmountStr = this.newAmountStr.trim();
      if(trimmedNewAmountStr.length === 0) {
        return this.item.amount;
      }
      return parseInt(trimmedNewAmountStr, 10);
    },

    /** @returns {number} */
    delta() {
      return this.newAmount - this.item.amount;
    },

    /** @returns {string} */
    deltaStr() {
      return convertDifferenceToOptionalStr(this.delta);
    },

    /** @returns {Object} */
    deltaClass() {
      const d = this.delta;

      return {
        muted:     d === 0,
        increased: d > 0,
        decreased: d < 0,
      };
    },

    /** @returns {Object} */
    newAmountClass() {
      return {
        muted: this.delta === 0,
      };
    },
  },

  methods: {
    getChangedItemData() {
      const oldAmount = this.item.amount;
      const newAmount = this.newAmount;
      if(oldAmount === newAmount) {
        return null;
      }

      return new InventoryItemData(
        this.item.id,
        newAmount
      );
    },
  },
};
</script>

<style scoped>
.new-amount-cont {
  padding-top:    0px;
  padding-bottom: 0px;
  vertical-align: middle;
}

.new-amount-input {
  padding-top:    0px;
  padding-bottom: 0px;
  height: 2.1em;
  text-align: right;
}

.muted,
.muted:focus {
  color: #dcdcdc;
}
</style>
